import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowIcon } from '../icons';
import { cardImage } from '../../utils/productImages';

// Pergola add-ons grid, dynamic from /api/products (filtered to
// category='accessory'). Renders nothing when the API has no
// accessories. accImgMap supplies a fallback CSS class (asg-acc-img-1
// through -4) when a particular accessory has no uploaded image.
export default function AccessoriesSection({ accessories, accImgMap }) {
  if (!accessories.length) return null;
  return (
    <section className="asg-accessories">
      <div className="asg-accessories-inner">
        <div className="asg-accessories-header asg-reveal">
          <p className="asg-section-label">Pergola Add-Ons</p>
          <h2 className="asg-section-title">Customise your pergola.</h2>
        </div>
        <div className="asg-accessories-grid">
          {accessories.map((a, idx) => (
            <div className="asg-acc-card asg-reveal" key={a._id}>
              <div className={`asg-acc-img ${!cardImage(a) ? (accImgMap[a._id] || `asg-acc-img-${idx + 1}`) : ''}`}>
                {cardImage(a) ? (
                  <img src={cardImage(a)} alt={a.name} width={600} height={400} loading="lazy" className="asg-acc-img-real" />
                ) : null}
              </div>
              <div className="asg-acc-info">
                <h3>{a.name}</h3>
                {a.short_description && <p>{a.short_description}</p>}
                <Link to={`/products/${a.slug || a._id}`} className="asg-link">
                  Learn more <ArrowIcon />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
